var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDesktopLg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1017,
    height: 662,
    viewBox: "0 0 1017 662",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M197.133 368.121C195.215 362.097 193.131 357.24 191.474 353.728C189.4 349.35 187.44 345.265 183.918 340.512C180.176 335.458 177.904 332.383 173.537 330.132C167.951 327.255 162.542 327.589 160.082 327.776C155.194 328.141 151.317 329.986 143.563 333.675C139.488 335.614 141.291 335.051 131.765 340.043C129.055 341.461 126.116 342.972 122.562 345.703C118.654 348.704 117.06 350.851 116.903 353.259C116.82 354.457 117.133 355.333 117.372 356.093C118.196 358.647 119.123 362.472 119.498 367.891",
    fill: "#F8EC30"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M997.555 369.538C996.679 354.342 997.951 342.221 999.326 333.79C1001.34 321.481 1003.58 317.083 1001.1 310.423C997.377 300.481 986.82 295.447 977.388 290.955C966.84 285.931 964.225 287.484 951.551 281.398C948.07 279.73 941.765 276.489 934.563 271.486C919.368 260.939 919.649 256.061 910.144 252.726C902.995 250.215 896.72 250.83 888.195 251.663C876.731 252.779 868.143 256.239 864.829 257.677C857.564 260.845 858.075 262.002 848.549 266.525C840.003 270.58 835.72 272.612 829.789 273.602C818.575 275.478 812.77 272.007 809.258 276.082C806.798 278.938 809.133 281.241 806.777 285.994C803.567 292.456 797.554 291.601 792.27 297.323C789.466 300.356 788.351 305.879 786.256 316.791C785.006 323.295 783.567 330.861 782.838 341.565C782.358 348.547 782.129 357.438 782.838 367.755",
    fill: "#F8EC30"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M733.738 367.652C730.944 360.241 731.247 354.801 732.091 351.133C732.893 347.641 733.977 346.703 735.634 340.981C736.895 336.604 738.052 332.633 737.99 328.235C737.906 321.732 735.207 317.073 731.142 310.069C726.807 302.586 726.056 303.91 721.231 295.916C716.041 287.307 716.249 284.671 711.559 279.637C707.609 275.395 703.555 273.071 701.648 272.081C699.313 270.872 692.112 267.255 683.003 268.068C677.125 268.589 677.521 270.33 667.192 272.55C660.866 273.915 657.614 274.582 653.268 273.967C651.955 273.779 649.964 273.394 640.293 269.246C632.768 266.015 631.695 265.275 629.204 264.295C620.48 260.867 612.382 261.669 607.255 262.169C593.716 263.503 591.621 268.568 569.62 275.739C560.22 278.803 555.509 280.335 551.569 280.345C550.621 280.345 547.984 280.293 544.847 281.409C544.847 281.409 541.658 282.545 538.833 284.952C534.685 288.485 533.539 323.806 536.707 372.029",
    fill: "#F8EC30"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M483.949 365.994C484.606 357.719 483.751 352.174 483.241 346.171C481.959 330.976 484.606 332.581 482.886 327.411C479.28 316.583 470.088 316.791 460.937 301.221C458.947 297.833 459.53 298.073 456.685 293.081C450.859 282.826 447.941 277.698 442.532 273.967C435.059 268.818 426.753 268.714 422.709 268.662C415.966 268.578 414.194 270.183 406.784 271.142C397.206 272.372 389.9 270.996 381.302 269.371C364.616 266.223 360.426 261.679 350.504 263.357C344.251 264.41 337.758 266.9 337.758 266.9C333.381 268.578 332.995 269.225 329.264 270.798C324.782 272.674 316.539 276.135 307.336 275.051C300.874 274.29 294.152 272.164 290.254 278.917C282.208 292.852 281.572 315.28 281.833 330.976C282.406 365.41 281.312 365.588 282.896 368.141C290.629 380.637 315.257 373.988 350.15 372.039C418.842 368.204 478.978 385.296 483.241 372.039C483.543 371.091 483.678 369.402 483.949 366.025V365.994Z",
    fill: "#F8EC30"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M194.238 370.246C193.55 368.016 192.425 365.014 190.518 361.752C186.609 355.061 181.805 351.278 180.429 350.246C177.532 348.057 172.143 344.003 164.504 343.346C160.346 342.992 156.656 344.055 149.288 346.181C143.441 347.87 139.48 349.6 136.01 351.132C125.629 355.728 124.004 358.156 123.441 359.094C121.169 362.878 121.137 367.359 121.137 367.588C121.137 369.277 121.408 370.673 121.669 371.663",
    fill: "#F8EC30"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M75.6141 201.762H1008.18V374.425H75.6141V201.762Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M989.416 371.309C992.011 358.897 992.022 348.61 991.542 341.575C990.896 332.153 990.344 325.348 985.529 319.272C981.746 314.519 977.014 312.299 969.958 309.715C947.165 301.346 929.249 299.449 929.249 299.449C907.436 297.135 908.572 300.283 886.071 298.386C859.525 296.155 854.856 291.518 845.007 296.26C833.866 301.627 837.243 308.818 821.641 318.209C814.189 322.701 804.684 326.307 798.629 331.664C798.024 332.206 794.627 335.249 789.78 339.095C787.79 340.668 786.987 341.242 786.591 341.575C783.663 344.003 781.735 350.642 786.237 369.183",
    fill: "#F8EC30"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M729.242 369.183C728.481 363.294 726.876 354.946 723.229 345.473C720.383 338.114 718.08 332.122 713.317 326.713C707.158 319.719 701.144 318.521 681.811 311.851C653.223 301.981 657.371 301.47 645.709 298.75C628.314 294.696 614.578 294.769 606.417 294.852C595.349 294.977 588.398 295.113 579.518 298.041C573.233 300.115 574.578 300.751 561.112 306.181C553.588 309.214 550.034 310.287 546.25 313.966C542.144 317.958 540.497 322.367 539.528 324.941C533.087 342.096 539.351 369.964 540.237 373.789",
    fill: "#F8EC30"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M480.066 367.412C478.722 362.586 476.721 356.76 473.699 350.424C472.854 348.662 469.749 342.274 463.787 333.79C454.115 320.022 449.279 313.144 441.129 310.778C437.409 309.704 433.459 309.704 425.559 309.715C416.189 309.725 415.647 310.893 411.405 310.069C402.87 308.422 403.109 303.357 393.709 299.803C386.455 297.062 379.618 297.552 372.823 298.032C370.071 298.23 366.507 298.865 359.368 300.158C343.453 303.024 343.995 303.691 339.899 303.701C328.581 303.733 326.621 298.688 320.076 300.866C316.231 302.148 317.314 303.753 306.976 314.321C301.712 319.71 300.035 320.71 292.468 328.475C288.737 332.31 286.861 334.228 286.1 335.197C283.161 338.938 278.44 348.287 286.1 371.299",
    fill: "#F8EC30"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M73.717 128.849V373.79H1011V128.849V0",
    stroke: "white",
    strokeWidth: 10.4221,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M1011 227.244H952.25V201.762H783.058V227.244H722.88V201.762H536.699V227.244H475.105V201.762H279.721V227.244H225.213V201.762H73.717",
    stroke: "white",
    strokeWidth: 10.4221,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M782.816 373.789V230.318",
    stroke: "white",
    strokeWidth: 10.4221,
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M536.695 373.789V230.318",
    stroke: "white",
    strokeWidth: 10.4221,
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M279.715 373.789V230.318",
    stroke: "white",
    strokeWidth: 10.4221,
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M657.75 120H206.451",
    stroke: "#F8EC30",
    strokeWidth: 5.21106,
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M1005.34 375.905H788.362",
    stroke: "#F8EC30",
    strokeWidth: 15.6332,
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M736.801 375.905H542.355",
    stroke: "#F8EC30",
    strokeWidth: 15.6332,
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M486.203 375.905H285.619",
    stroke: "#F8EC30",
    strokeWidth: 15.6332,
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M201.855 375.905H117.259",
    stroke: "#F8EC30",
    strokeWidth: 15.6332,
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M73.7148 379.001V659.335H-0.000850343",
    stroke: "#F8EC30",
    strokeWidth: 5.21106,
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M231.234 166.014H274.059V221.584H231.234V166.014Z",
    fill: "#17375E"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M480.774 166.014H531.27V221.584H480.774V166.014Z",
    fill: "#17375E"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M728.181 166.014H777.738V222.179H728.181V166.014Z",
    fill: "#17375E"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M955.783 166.014H1005.34V222.179H955.783V166.014Z",
    fill: "#17375E"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesktopLg);
export default __webpack_public_path__ + "static/media/desktop-lg.c2a0a6dff3924ab71f36219daab61f86.svg";
export { ForwardRef as ReactComponent };